// Função helper para ordenação alfabética robusta em português
export const sortByName = (a, b) => {
  const nameA = a.nome.trim().toLowerCase();
  const nameB = b.nome.trim().toLowerCase();
  
  // Usar apenas comparação simples que funciona consistentemente
  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};
